import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProviderState {
  provider: any;
  providerNPI: string;
  vbcCount: number;
  cdiCount: number;
  myQueriesCount: number;
  umQueriesCount: number;
  opcdQueriesCount: number;
  opcdHimAlertsCount: number;
  opcdCodingAlertsCount: number;
}

const initialState: ProviderState = {
  provider: {},
  providerNPI: "",
  vbcCount: 0,
  cdiCount: 0,
  myQueriesCount: 0,
  umQueriesCount: 0,
  opcdQueriesCount: 0,
  opcdHimAlertsCount: 0,
  opcdCodingAlertsCount: 0,
};

const providerSlice = createSlice({
  name: "provider",
  initialState,
  reducers: {
    setProvider: (state, action: any) => {
      state.provider = action.payload;
    },
    setProviderNPI: (state, action: PayloadAction<string>) => {
      state.providerNPI = action.payload;
    },
    resetProvider: (state) => {
      state.provider = initialState.provider;
      state.providerNPI = initialState.providerNPI;
    },
    setVBCCount: (state, action: PayloadAction<number>) => {
      state.vbcCount = action.payload;
    },
    setCDICount: (state, action: PayloadAction<number>) => {
      state.cdiCount = action.payload;
    },
    setMyQueriesCount: (state, action: PayloadAction<number>) => {
      state.myQueriesCount = action.payload;
    },
    setUmQueriesCount: (state, action: PayloadAction<number>) => {
      state.umQueriesCount = action.payload;
    },
    setOpcdQueriesCount: (state, action: PayloadAction<number>) => {
      state.opcdQueriesCount = action.payload;
    },
    setOpcdHimAlertsCount: (state, action: PayloadAction<number>) => {
      state.opcdHimAlertsCount = action.payload;
    },
    setOpcdCodingAlertsCount: (state, action: PayloadAction<number>) => {
      state.opcdCodingAlertsCount = action.payload;
    },
  },
});

export const {
  setProvider,
  setProviderNPI,
  resetProvider,
  setVBCCount,
  setCDICount,
  setMyQueriesCount,
  setUmQueriesCount,
  setOpcdQueriesCount,
  setOpcdHimAlertsCount,
  setOpcdCodingAlertsCount,
} = providerSlice.actions;

export default providerSlice.reducer;
